// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor-js__wrapper .editor-js.error[data-v-de38ebf8]{border-color:#e44545}", ""]);
// Exports
module.exports = exports;
